export const WKT_INPUT = "wkt_geom_input_";
export const LATITUDE_INPUT = "latitude_geom_input_";
export const LONGITUDE_INPUT = "longitude_geom_input_";
export const GEOJSON_INPUT = "geojson_geom_input_";
export const DRAW_POLYGON_INPUT = "draw_polygon_";
